import { isNativeApp, nativePlatform } from './push';

let started = false;

/** Push-Zielpfad → App-Route unter /m. */
export function resolveNativePushPath(raw) {
  if (!raw || typeof raw !== 'string') return '/m';
  const s = raw.trim();
  if (!s) return '/m';
  try {
    if (s.startsWith('http://') || s.startsWith('https://')) {
      const u = new URL(s);
      return `${u.pathname}${u.search}${u.hash}` || '/m';
    }
  } catch (_e) { /* ignore */ }
  if (s.startsWith('/m')) return s;
  if (s.startsWith('/')) return `/m${s === '/' ? '' : s}`;
  return `/m/${s}`;
}

/**
 * Verbindet Capacitor-Shell mit der Live-Companion:
 * StatusBar, Push-Tap → Navigation, App-State.
 * Idempotent; im Browser no-op.
 */
export async function initNativeShell(navigate) {
  if (started || !isNativeApp()) return false;
  started = true;

  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    const ios = nativePlatform() === 'ios';
    const login = window.location.pathname.startsWith('/m/login');
    await StatusBar.setStyle({ style: ios && !login ? Style.Light : Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#F5F5F6' }).catch(() => {});
  } catch (_e) { /* Plugin optional */ }

  try {
    const { App } = await import('@capacitor/app');
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) window.history.back();
      else App.exitApp();
    });
  } catch (_e) { /* ignore */ }

  try {
    const { PushNotifications } = await import('@capacitor/push-notifications');
    const go = (url) => {
      const path = resolveNativePushPath(url);
      if (typeof navigate === 'function') {
        const rel = path.startsWith('/m') ? path.slice(2) || '/' : path;
        navigate(rel.startsWith('/') ? rel : `/${rel}`);
      } else {
        window.location.assign(path);
      }
    };
    await PushNotifications.addListener('pushNotificationActionPerformed', (event) => {
      const data = event?.notification?.data || {};
      go(data.url || data.path || '/m');
    });
  } catch (_e) { /* ignore */ }

  return true;
}

/** Nur für Tests. */
export function _resetNativeShellForTests() {
  started = false;
}
